import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import StaticAlbumGallery from "./sections/StaticAlbumGallery";
import StaticAlbumGalleryCopy from "@/pages/Portfolio/sections/StaticAlbumGalleryCopy";
import StaticAlbumGalleryCopyCopy from "@/pages/Portfolio/sections/StaticAlbumGalleryCopyCopy";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <StaticAlbumGallery />
      <StaticAlbumGalleryCopy />
      <StaticAlbumGalleryCopyCopy />
      <Footer />
    </div>;
}